import { render, staticRenderFns } from "./GroupItem.vue?vue&type=template&id=8806b010"
import script from "./GroupItem.vue?vue&type=script&lang=js"
export * from "./GroupItem.vue?vue&type=script&lang=js"
import style0 from "./GroupItem.vue?vue&type=style&index=0&id=8806b010&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports